export class MessageEntity {

    public static toDtoArray(entityArray: MessageEntity[]): any[] {
        const dtos = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }

    public email: string = null;
    public message: string = null;

    public toDto(): any {
        return {
            email: this.email,
            message: this.message
        };
    }
}
